import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { OverviewDashboardSummary } from './overview-dashboard.model';
import {
  ButtonComponent,
  DecimalRuleOperation,
  HashratePipe,
  ModalService,
  SvgIconComponent,
} from '@ui-lib/components';
import { OverviewDashboardModalComponent } from './overview-dashboard-modal/overview-dashboard-modal.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DecimalRuleDescription } from '@ui-lib/components/lib/utils';
import { FormattedCountPipe } from '../../../../shared/pipes/formatted-count.pipe';
import { SolHashratePipe } from '../../../../shared/pipes/sol-hashrate.pipe';
import { FormattedTemperaturePipe } from '../../../../shared/pipes/formatted-temperature.pipe';
import { AsyncPipe } from '@angular/common';
import { OverviewDashboardService } from './overview-dashboard.service';
import { LoadingState } from '../../../../shared/types/loading.type';
import { PowerPipe } from '../../../../shared/pipes/power.pipe';

@Component({
  standalone: true,
  selector: 'mon-overview-dashboard',
  templateUrl: './overview-dashboard.component.html',
  styleUrls: ['./overview-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    ButtonComponent,
    SvgIconComponent,
    HashratePipe,
    FormattedCountPipe,
    SolHashratePipe,
    FormattedTemperaturePipe,
    AsyncPipe,
    PowerPipe,
  ],
  providers: [OverviewDashboardService],
})
export class OverviewDashboardComponent implements OnInit {
  protected readonly overviewDashboardService = inject(OverviewDashboardService);
  private readonly modalService = inject(ModalService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly LoadingState = LoadingState;

  protected readonly hashrateDecimalRule: DecimalRuleDescription = {
    operation: DecimalRuleOperation.Cut,
    decimalAmount: 2,
  };

  private currentSummary: OverviewDashboardSummary | null = null;

  public ngOnInit(): void {
    this.overviewDashboardService.summary$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((summary) => (this.currentSummary = summary));
  }

  public openOverviewDashboardModal(title: string): void {
    this.modalService.open({
      component: OverviewDashboardModalComponent,
      data: { title, summary: this.currentSummary },
      customContainerClass: 'overview-dashboard-modal',
    });
  }
}
